import styled from "styled-components";

export const Container = styled.div`
  margin-top: 14rem;
  margin-bottom: 8rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  .sobre-banner {
    display: flex;
    font-family: "Poppins", sans-serif;
    flex-direction: row;
    width: 97%;
  }
  .sobre-banner p {
    font-size: 1.2rem;
    line-height: 1.6rem;
    font-family: "Poppins", sans-serif;
    color: #adadad;
    font-weight: 400;
    margin-top: 0.2rem;
    width: 90%;
  }
  .p-2 {
    font-size: 1.2rem;
    line-height: 1.6rem;
    font-family: "Poppins", sans-serif;
    color: #adadad;
    font-weight: 400;
    margin-top: -0.2rem;
    margin-left: 4rem;
  }
  .sobre-banner img {
    width: 40%;
    height: 20rem;
    margin-left: -1rem;
    margin-right: -1rem;
  }
  @media (max-width: 999px) {
    display: none;
    .sobre-img {
      display: none;
    }

    .sobre-banner {
      text-align: center;
    }
  }
`;
